const config = {
  SERVER: {
    BASE_URL: 'https://api.evosquare.net',
    API_PATH: '/evoSquare/Auth',
    FRIEND_PATH: '/evoSquare/Friendship',

    // A projektben többféle elnevezés előfordulhat (Auth vs Presence),
    // ezért itt alapértelmezetten Auth-ot használunk, és a kliens fallback-kel kezeljük a többit.
    PRESENCE_PATH: '/evoSquare/Auth',
    PRESENCE_FALLBACK_PATH: '/evoSquare/Presence',

    CHAT_PATH: '/evosquare/Chat',
    CHAT_HUB_PATH: '/chatHub'
  },
  DEFAULT_GAME_SETTINGS: {
    timerMinutes: 15,
    squareSize: 60,
    pieceFontSize: 45,
    layoutMode: 'responsive',
    maxAllowedGameTimeMinutes: 15,
    maxAllowedTurnTimeSeconds: 30
  }
};

export const API_ENDPOINTS = {
  LOGIN: `${config.SERVER.BASE_URL}${config.SERVER.API_PATH}/Login`,
  REGISTER: `${config.SERVER.BASE_URL}${config.SERVER.API_PATH}/Register`,

  CREATE_LOBBY: `${config.SERVER.BASE_URL}/evosquare/Lobby/CreateLobby`,
  JOIN_LOBBY: `${config.SERVER.BASE_URL}/evosquare/Lobby/JoinLobby`,
  GET_LOBBY: `${config.SERVER.BASE_URL}/evosquare/Lobby/GetLobbyById`,
  LEAVE_LOBBY: `${config.SERVER.BASE_URL}/evoSquare/Lobby/LeaveLobby`,
  CLOSE_LOBBY: `${config.SERVER.BASE_URL}/evoSquare/Lobby/CloseLobby`,

  START_GAME: `${config.SERVER.BASE_URL}/evoSquare/Game/StartGame`,
  MOVE: `${config.SERVER.BASE_URL}/evoSquare/Game/Move`,
  STATUS: `${config.SERVER.BASE_URL}/evoSquare/Game/Status`,
  HISTORY: `${config.SERVER.BASE_URL}/evoSquare/Game/History`,

  GETFRIENDLIST: `${config.SERVER.BASE_URL}${config.SERVER.FRIEND_PATH}/List`,
  SENDFRIENDREQUEST: `${config.SERVER.BASE_URL}${config.SERVER.FRIEND_PATH}/SendRequest`,
  REMOVEFRIEND: `${config.SERVER.BASE_URL}${config.SERVER.FRIEND_PATH}/Remove`,
  ACCEPTORDENY: `${config.SERVER.BASE_URL}${config.SERVER.FRIEND_PATH}/AcceptOrDenyRequest`,
  TOGGLEBLOCK: `${config.SERVER.BASE_URL}${config.SERVER.FRIEND_PATH}/ToggleBlock`,

  SEARCH_USERS: `${config.SERVER.BASE_URL}/evoSquare/User/Search`,

  // Presence / online
  ONLINEPING: `${config.SERVER.BASE_URL}/evoSquare/Presence/Ping`,
  GOOFFLINE: `${config.SERVER.BASE_URL}${config.SERVER.PRESENCE_PATH}/GoOffline`,
  LISTONLINEUSERS: `${config.SERVER.BASE_URL}/evoSquare/Presence/ListOnlineUsers`,

  // Chat
  GET_CHAT_HISTORY: `${config.SERVER.BASE_URL}${config.SERVER.CHAT_PATH}/history`,
  SEND_MESSAGE: `${config.SERVER.BASE_URL}${config.SERVER.CHAT_PATH}/send`,

  CHAT_GLOBAL_HISTORY: `${config.SERVER.BASE_URL}${config.SERVER.CHAT_PATH}/Global`,
  CHAT_LOBBY_HISTORY: (lobbyId) => `${config.SERVER.BASE_URL}${config.SERVER.CHAT_PATH}/Lobby?lobbyId=${encodeURIComponent(lobbyId)}`,
  CHAT_PRIVATE_HISTORY: (userA, userB) => `${config.SERVER.BASE_URL}${config.SERVER.CHAT_PATH}/Private?userA=${encodeURIComponent(userA)}&userB=${encodeURIComponent(userB)}`,
  CHAT_HUB: `${config.SERVER.BASE_URL}${config.SERVER.CHAT_HUB_PATH}`,

  GET_PUBLIC_USER: (uid) => `${config.SERVER.BASE_URL}/evoSquare/User/Public/${encodeURIComponent(uid)}`,
  GET_LOBBY_BY_INVITE: (code) => `${config.SERVER.BASE_URL}/evosquare/Lobby/GetLobby?inviteCode=${encodeURIComponent(code)}`,

  LISTONLINEUSERS_AUTH: `${config.SERVER.BASE_URL}${config.SERVER.API_PATH}/ListOnlineUsers`,
  LISTONLINEUSERS_PRESENCE: `${config.SERVER.BASE_URL}${config.SERVER.PRESENCE_FALLBACK_PATH}/ListOnlineUsers`,

  // Backward compatible aliasok (ha valahol más néven hivatkozol rá)
  ONLINE_PING: `${config.SERVER.BASE_URL}${config.SERVER.PRESENCE_PATH}/Ping`,
  GO_OFFLINE: `${config.SERVER.BASE_URL}${config.SERVER.PRESENCE_PATH}/GoOffline`,
  GETONLINEUSERS: `${config.SERVER.BASE_URL}${config.SERVER.PRESENCE_PATH}/ListOnlineUsers`
};

export default config;